import {DictionaryModel} from "../../../../shared/models/dictionary.model";
import {EmptySearchParamsFilterModel} from "../../../../shared/models/search/params/filters/empty-search-params-filter.model";

export class HlaCollectionParamsFilterModel extends EmptySearchParamsFilterModel {
    public constructor(
        public iHWNumber: string,
        public serologicalFields: DictionaryModel<string>,
        public dnaProbeFields: DictionaryModel<string>,
        public nonHlaGenesFields: DictionaryModel<string>,
    ) {
        super();
    }
}
